import { useMemo } from 'react';
import { useOverviewLinkState } from '../linkstate/ReportsOverview.linkstate';
import { ReportsQueryFilter } from '../../../../shared/types';
import { useGetReportsTripsQuery } from '../../../../GraphQL/hooks/useGetReportsTripsQuery';
import { useUserState } from '../../../../Hooks/useUserState';

export const useSortedReportsTripsQuery = () => {
    const [state] = useOverviewLinkState();
    const { quickCalendarFilter, selectedDateRange } = state;
    const { ...userState } = useUserState();

    const request = useMemo(
        () =>
            ({
                quicklyCalanderSlot: quickCalendarFilter ?? '',
                dateRange: selectedDateRange,
                operatorId: userState.operatorId,
            }) as ReportsQueryFilter,
        [quickCalendarFilter, selectedDateRange]
    );
    const { data: tripsData, refetch, loading: loadingTrips } = useGetReportsTripsQuery(request);

    return {
        tripsData,
        refetchTrips: () => refetch({ request }),
        loadingTrips,
    };
};
